import dayjs from 'dayjs';
import { RxDatabase } from 'rxdb';

import {
	Api,
	CapacityCheckSearchDirectionDto,
	deleteSearchApi,
	getSearchApi,
	patchSearch1Api,
	patchSearchApi,
	postSearchApi,
	PrivateTripSearchView,
	TCapacityCheckProcessInstance,
} from '@mopla/data-models';

import {
	IPRODTCapacityCheckAPI,
	TPatchSearchV2Payload,
	TPostCapacityCheckPayload,
} from './types';

function mapPrivateTripResponse(
	data: PrivateTripSearchView
): TCapacityCheckProcessInstance<'PRODT'> {
	/**
	 * TODO think how to make PrivateTripSearchView compatible with TCapacityCheckProcessInstance<'PRODT'>;
	 * In fact they are compatible
	 * */
	return data as unknown as TCapacityCheckProcessInstance<'PRODT'>;
}

export class PRODTApi implements IPRODTCapacityCheckAPI {
	constructor(private api: Api, private db: RxDatabase) {}

	async postSearch(
		payload: TPostCapacityCheckPayload<'PRODT'>
	): Promise<TCapacityCheckProcessInstance<'PRODT'>> {
		const res = await postSearchApi({
			body: {
				...payload,
				// The BE searches for reservations in an 8s window around the requested datetime.
				// Without this, random seconds from the FE can shift that window into the previous
				// or next minute (e.g. seconds=55 would miss reservations at the full minute).
				// Fixing seconds to 10 keeps the window (02s–18s) safely within the target minute.
				// https://mopla-solutions.atlassian.net/browse/MC-10172
				datetime: dayjs(payload.datetime).second(10).toISOString(),
			},
		});

		return mapPrivateTripResponse(res.data);
	}

	async getSearch(
		searchId: string
	): Promise<TCapacityCheckProcessInstance<'PRODT'>> {
		const res = await getSearchApi({ path: { searchId } });

		return mapPrivateTripResponse(res.data);
	}

	async patchSearch(
		searchId: string,
		payload: CapacityCheckSearchDirectionDto
	): Promise<void> {
		await patchSearch1Api({ path: { searchId }, body: payload });
	}

	async patchSearchV2(
		searchId: string,
		payload: TPatchSearchV2Payload
	): Promise<TCapacityCheckProcessInstance<'PRODT'>> {
		const res = await patchSearchApi({ path: { searchId }, body: payload });

		return mapPrivateTripResponse(res.data);
	}

	async deleteSearch(searchId: string): Promise<void> {
		await deleteSearchApi({ path: { searchId } });
	}
}
